import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { ReactComponent as OwTextIcon } from "assets/img/ow-text-icon.svg";
import { MyHrLoginTwoFactorSelectTypeOptions } from "my-hr/components";

interface MyHrLoginTwoFactorSelectTypeProps {
  onCancel: () => void;
  onForward: (nextStep: string) => void;
  isMobile: boolean;
}

export const MyHrLoginTwoFactorSelectType = ({
  onCancel,
  onForward,
  isMobile,
}: MyHrLoginTwoFactorSelectTypeProps) => {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState("email");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedType(event.target.value);
  };

  return (
    <Box
      sx={{
        width: isMobile ? "auto" : "304px",
        padding: isMobile ? "0px 24px" : "unset",
      }}
    >
      <OwTextIcon />
      <Typography
        variant="h6"
        sx={{
          marginTop: "24px",
        }}
      >
        {t("MY_HR_2FA_AUTHENTICATION")}
      </Typography>
      <Box sx={{ textAlign: "left", marginTop: "24px", marginBottom: "16px" }}>
        <Typography variant="body1">{t("MY_HR_2FA_CHOOSE_OPTION")}</Typography>
      </Box>
      <Box
        sx={{
          maxHeight: isMobile ? "auto" : "550px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <MyHrLoginTwoFactorSelectTypeOptions
          value="email"
          checked={selectedType === "email"}
          onChange={handleChange}
          label={t("MY_HR_EMAIL_BASED_AUTHENTICATION")}
          description={t("MY_HR_EMAIL_AUTHENTICATION_DESCRIPTION")}
        />
        <Box sx={{ textAlign: "left", marginBottom: "16px" }}>
          <Box height="16px" />
          <MyHrLoginTwoFactorSelectTypeOptions
            value="totp"
            checked={selectedType === "totp"}
            onChange={handleChange}
            label={t("MY_HR_APP_BASED_AUTHENTICATION")}
            description={t("MY_HR_APP_AUTHENTICATION_DESCRIPTION")}
          />
        </Box>
      </Box>
      <Button
        id="next"
        variant="contained"
        color="primary"
        sx={{ marginTop: "16px" }}
        onClick={() =>
          onForward(
            selectedType === "totp"
              ? "two-factor-totp-info"
              : "two-factor-email-register",
          )
        }
        fullWidth
      >
        {t("OC_NEXT")}
      </Button>
      <Button
        id="cancel"
        variant="text"
        color="secondary"
        fullWidth
        sx={{ color: "#212121", marginTop: "32px" }}
        onClick={onCancel}
      >
        {t("OC_CANCEL")}
      </Button>
    </Box>
  );
};

export default MyHrLoginTwoFactorSelectType;
